const reward = 10;

const state = {
  lastCorrectPlayerId: 0
};

const actions = {
  startRound: ({ commit }) => {
    commit('ACTIVATE_PLAYER', 0, { root: true });
    commit('SHOW_ROUND_PLAYSCREEN', null, { root: true });
    commit('SET_CURRENT_QUESTION', 0, { root: true });
    commit('SET_LAST_CORRECT_PLAYER', 0);
  },
  answerQuestion: ({ commit, dispatch, getters, rootGetters }, answer) => {
    // Correct Answer
    if (answer.correct) {
      if (getters.questionNr % 3 === 0) {
        commit(
          'REWARD_PLAYER',
          { playerId: answer.playerId, score: reward },
          { root: true }
        );
      }
      commit('SET_LAST_CORRECT_PLAYER', answer.playerId);
      commit('ACTIVATE_PLAYER', answer.playerId, { root: true });
      dispatch('nextQuestion');
      // Wrong Answer
    } else {
      commit('END_PLAYER_TURN', answer.playerId, { root: true });
      // Get the next player
      if (rootGetters.nextPlayerByOrder) {
        commit('ACTIVATE_PLAYER', rootGetters.nextPlayerByOrder.id, {
          root: true
        });
        // Go to the next question if there aren't any players left
      } else {
        commit('ACTIVATE_PLAYER', getters.lastCorrectPlayer.id, { root: true });
        dispatch('nextQuestion');
      }
    }
  },
  nextQuestion: ({ commit, dispatch, getters }) => {
    if (getters.hasQuestionsLeft) {
      commit('NEXT_QUESTION', null, { root: true });
      commit('RESET_ALL_PLAYERS_TURNS', null, { root: true });
    } else {
      dispatch('nextRound', null, { root: true });
    }
  }
};

const mutations = {
  SET_LAST_CORRECT_PLAYER: (state, playerId) => {
    state.lastCorrectPlayerId = playerId;
  }
};

const getters = {
  questions(state, getters, rootState) {
    return rootState.questionsPerRound[0].questions;
  },
  activeQuestion(state, getters, rootState) {
    return getters.questions[rootState.game.currentQuestion];
  },
  hasQuestionsLeft(state, getters) {
    return getters.questionNr < getters.questions.length;
  },
  questionNr(state, getters, rootState) {
    return rootState.game.currentQuestion + 1;
  },
  lastCorrectPlayer(state, getters, rootState, rootGetters) {
    return rootGetters.players[state.lastCorrectPlayerId];
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
